import React from 'react';
import PropTypes from 'prop-types';

const NavArrowUp = ({ fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="13.152" height="7.627" viewBox="0 0 13.152 7.627">
      <g id="Group_635" data-name="Group 635" transform="translate(13.152) rotate(90)">
        <path id="Path_185" data-name="Path 185" d="M7.627,12.271l-.856.881L0,6.576,6.771,0l.856.882L1.764,6.576Z" fill={fill} />
      </g>
    </svg>
  )
}

NavArrowUp.defaultProps = {
  fill: '#000'
}

NavArrowUp.propTypes = {
  fill: PropTypes.string
}

export default NavArrowUp;
